import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'

const CreateSessionSale = props => {
  return (
    <Create
// @ts-ignore
      title='Create Session Sale'
      fields={fields}
      apiPath='admin/session_sales'
      successRedirectPath={resource => `/events/session-sales/${resource.id}/edit`}
      buildMenuItems={menuItems}
      resource={{ enable_invoice_request: false }}
    />
  )
}

export default CreateSessionSale
